import { useRef } from 'react'
import {
    Box,
    Card as ThemeCard,
    Flex,
    Heading,
    Image,
    Text,
    Badge
} from '@theme-ui/components';
import { CSSTransition } from 'react-transition-group';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
    ImagePlaceholder,
    Skeleton,
} from '~/Common'
import { useDisplayName } from 'hooks/useDisplayName';
import { Icon } from 'assets/Icon';
import { useResponsiveValue } from '@theme-ui/match-media';

export const CompanyCard = ({ industry }) => {
    const nodeRef = useRef(null);
    const { t } = useTranslation();
    const companyDisplayName = useDisplayName(industry);
    const isMobile = useResponsiveValue([true, true, true, false]);

    return (
        <CSSTransition
            nodeRef={nodeRef}
            in={true}
            timeout={500}
            classNames="fade"
            unmountOnExit
            appear
        >
            <ThemeCard
                as={Link}
                to={`/industries/${industry?.slug}`}
                variant={isMobile ? 'industryMobile' : 'industry'}
                ref={nodeRef}
            >
                <Flex sx={{ position: 'relative', zIndex: 1, minWidth: '120px' }}>
                    {industry ? (
                        <>
                            {industry?.image?.sizes?.thumbnail ? (
                                <Box sx={{
                                    width: isMobile ? '120px' : '100%',
                                    height: isMobile ? '100%' : '168px'
                                }}>
                                    <Image src={industry?.image?.sizes?.thumbnail} sx={{ objectFit: 'cover', height: '100%', width: isMobile ? '120px' : '100%' }} />
                                </Box>
                            ) : (
                                <ImagePlaceholder sx={{
                                    width: isMobile ? '120px' : '100%',
                                    height: isMobile ? '100%' : '168px'
                                }} />
                            )}
                        </>
                    ) : <Skeleton height="168px" />}
                </Flex>
                <Flex px={[3,3,3,'26px']} py={4} sx={{
                    position: 'relative',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    flexGrow: 1
                }}>
                    <Box sx={{ flexGrow: 1 }}>
                        {industry ? <Heading as="h3" variant="h3">{t(companyDisplayName)}</Heading> : <Skeleton height="28px" width="70%" />}
                        {industry ? <Text variant="p" color="dark" >{industry?.email_summary}</Text> : <Skeleton height="14px" width="100%" />}

                        {industry ? (
                            <>
                                {Boolean(industry?.deals_count || industry?.companies_count) && (
                                    <Flex sx={{
                                        mt: 3,
                                        flexDirection: 'row',
                                        gap: 1
                                    }}>
                                        {industry?.companies_count ? (
                                            <Box>
                                                <Badge variant="coins">
                                                    <Box sx={{ display: 'flex', alignItems: 'center', paddingX: '6px' }}>
                                                        <Icon icon="stack" size="16" />
                                                        <Text sx={{
                                                        minWidth: '20px',
                                                        textAlign: 'center',
                                                        fontSize: isMobile ? '12px' : 1,
                                                        letterSpacing: '-0.01em',
                                                        lineHeight: '20px',
                                                        px: 2
                                                        }}>{industry?.companies_count ?? 0 }</Text>
                                                    </Box>
                                                </Badge>
                                            </Box>
                                        ) : null}

                                        {industry?.deals_count || true ? (
                                            <Box>
                                                <Badge variant="coins">
                                                    <Box sx={{ display: 'flex', alignItems: 'center', paddingX: '6px' }}>
                                                        <Icon icon="stack" size="16" />
                                                        <Text sx={{
                                                        minWidth: '20px',
                                                        textAlign: 'center',
                                                        fontSize: isMobile ? '12px' : 1,
                                                        letterSpacing: '-0.01em',
                                                        lineHeight: '20px',
                                                        px: 2
                                                        }}>{industry?.deals_count ?? 0 } current deals</Text>
                                                    </Box>
                                                </Badge>
                                            </Box>
                                        ) : null}
                                    </Flex>
                                )}
                            </>
                        ) : (
                            <Box mt={3}>
                                <Skeleton height="14px" width="30px" mb={2} />
                                <Skeleton height="40px" width="80px" />
                            </Box>
                        )}
                    </Box>
                </Flex>
            </ThemeCard>
        </CSSTransition>
    );
};
